<template>
  <div id="app">
    <router-view name="home"></router-view>
    <router-view name="cs"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue